import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import utils from '../utils/Utils';
// import Menu from './Menu';
import backgroundImage from '../assets/ClipdeoHome.png'

const LayoutBlank = ({ children }) => {
  useEffect(() => {
    utils.scaleMobile();
  
    return () => {
    }
  }, [])
  
  return (
  <>
    <div>
        {/* <Menu /> */}
        <div className="page-content">
          <div className="min-h-[calc(100vh-0px)] flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
          >
            {children}
          </div>
        </div>
        <ToastContainer
            position="bottom-right"
            autoClose={4000}
            draggable
            hideProgressBar={true}
        />
    </div>
  </>
  );
};

export default LayoutBlank;

